import styled from '@emotion/styled'

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

export const ProgressBarContent = styled.div`
  width: 500px;
`
